import t_04_2346_colored from './KZ.T.04.2346.svg'
import t_04_2346 from './KZ.T.04.2346 black.svg'

export default [
  t_04_2346_colored,
  t_04_2346
]
